import { ca } from '@cian/analytics';

import type { ICallbackParams } from '@cian/newbuilding-flat-view-order-component';

export function trackFlatTourBookingSuccess(id: number, bookingParams: ICallbackParams) {
  const { date, time, phone, name, timestamp } = bookingParams;

  ca('eventSite', {
    name: 'oldevent',
    category: 'PersonalTour',
    action: 'Success',
    label: 'Submit',
    products: [
      {
        id,
        offerType: 'JK',
        extra: {
          date,
          time,
          phone,
          name,
          timestamp,
        },
      },
    ],
  });
}
